import { render } from "./ClampedVehicles.vue?vue&type=template&id=850e757c"
import script from "./ClampedVehicles.vue?vue&type=script&lang=js"
export * from "./ClampedVehicles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__